import React, { useContext } from "react";
import { useTheme } from "@material-ui/core";

import { i18n } from "../../translate/i18n";
import { AEROS } from "../../styles/aerosTokens";
import { descreveFalha } from "../../helpers/erroMeta";
import { WhatsAppsContext } from "../../context/WhatsApp/WhatsAppsContext";

// Aviso discreto acima do campo de texto quando a conexao do ticket esta com
// erro de conta na Meta. Nao bloqueia o envio.
const AvisoContaComposer = ({ whatsappId }) => {
  const theme = useTheme();
  const { whatsApps = [] } = useContext(WhatsAppsContext) || {};
  const conexao = whatsApps.find(w => Number(w.id) === Number(whatsappId));
  if (!conexao || !conexao.accountIssueCode) return null;

  const { titulo } = descreveFalha({
    failureCode: conexao.accountIssueCode,
    failureReason: conexao.accountIssueReason,
    failureLink: conexao.accountIssueLink,
  });
  const light = theme?.palette?.type === "light";
  const cor = light ? AEROS.stateTextOnLight.warning : AEROS.warning;

  return (
    <div
      role="status"
      style={{
        padding: "6px 12px",
        borderLeft: `3px solid ${cor}`,
        color: cor,
        fontSize: 13,
        lineHeight: 1.5,
        overflowWrap: "anywhere",
      }}
    >
      {i18n.t("metaErrors.composerWarning", { titulo })}
    </div>
  );
};

export default AvisoContaComposer;
